import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as RadixTabs from '@radix-ui/react-tabs';
import { useEffect, useRef, useState } from 'react';
import styles from './Tabs.module.css';
function useDefile() {
    const liste = useRef(null);
    const [defile, setDefile] = useState(false);
    useEffect(() => {
        const element = liste.current;
        if (!element)
            return;
        const mesurer = () => setDefile(element.scrollWidth > element.clientWidth);
        mesurer();
        if (typeof ResizeObserver === 'undefined')
            return;
        const observateur = new ResizeObserver(mesurer);
        observateur.observe(element);
        return () => observateur.disconnect();
    }, []);
    return [liste, defile];
}
/** Onglets (Radix `Tabs`), navigation clavier flèches/Home/End incluse. */
export function Tabs({ tabs, value, defaultValue, onValueChange }) {
    const [liste, defile] = useDefile();
    return (_jsxs(RadixTabs.Root, { value: value, defaultValue: defaultValue ?? tabs[0]?.value, onValueChange: onValueChange, children: [_jsx(RadixTabs.List, { ref: liste, className: styles.list, "data-defile": defile ? 'true' : undefined, children: tabs.map((tab) => (_jsx(RadixTabs.Trigger, { value: tab.value, disabled: tab.disabled, className: styles.trigger, children: tab.label }, tab.value))) }), tabs.map((tab) => (_jsx(RadixTabs.Content, { value: tab.value, className: styles.content, children: tab.content }, tab.value)))] }));
}
//# sourceMappingURL=Tabs.js.map